import { useTranslation } from 'react-i18next';
/////////////////////////////////////////////////////////////
import { useCustomSelector } from '@/core/redux/hooks';

import {
	Drawer,
	DrawerContent,
	DrawerClose,
	DrawerFooter,
	DrawerHeader,
	DrawerTitle,
	Close,
	DrawerDescription,
	CoinImage,
	DiamondImage,
	ScrollArea,
} from '@/app/shared/components';
import { VisuallyHidden } from '@radix-ui/react-visually-hidden';
import { numify } from 'numify';

interface InfoDailyComboProps {
	isOpen: boolean;
	onClose: React.Dispatch<React.SetStateAction<boolean>>;
}

export const InfoDailyCombo: React.FC<InfoDailyComboProps> = ({
	isOpen,
	onClose,
}: InfoDailyComboProps) => {
	/*********************
	// #region Hooks
	**********************/
	// const dispatch = useCustomDispatch();
	const { t } = useTranslation();

	/*********************
	// #region Redux
	**********************/
	const { levelComboList } = useCustomSelector((state) => state.counter);

	/*********************
	// #region Functions
	**********************/

	/*********************
	// #region Template
	**********************/
	return (
		<Drawer open={isOpen} onOpenChange={onClose}>
			<DrawerContent>
				<div className="mx-auto mt-4 h-2 w-[100px] rounded-full bg-muted" />
				<div className="mx-auto w-full max-w-sm ">
					<DrawerHeader>
						<DrawerTitle>
							<VisuallyHidden>
								{t('dailycombo.reveal.title')}
							</VisuallyHidden>
							<DrawerClose className="right-5 text-right absolute">
								<Close fillcolor="#fff" />
							</DrawerClose>
						</DrawerTitle>
					</DrawerHeader>
					<DrawerDescription>
						<VisuallyHidden></VisuallyHidden>
					</DrawerDescription>

					<div>
						<p className="text-sm text-center">
							{t('dailycombo.info.text')}
						</p>

						<ScrollArea className="h-[calc(100dvh-120px)] w-full px-3 flex flex-col mx-auto mt-2">
							<div className="flex flex-col mx-auto py-4 gap-4 px-4">
								{levelComboList.map((item) => {
									return (
										<div
											key={item.level}
											className="flex rounded-2xl items-center bg-customer-900/50 p-2 option-menu-setting py-3 "
										>
											<div className="flex flex-1 gap-2 items-center">
												<p className="text-[10px] font-bold">
													{item.level}
												</p>

												<p className="text-[10px] font-bold">
													{item.name}
												</p>
											</div>

											<div className="flex gap-2">
												<div className="flex gap-1 items-center">
													<p className="text-[10px]">
														{numify(
															item.shurikenRewards
														)}
													</p>

													<CoinImage classes="drop-shadow-sm w-[20px]" />
												</div>

												<div className="flex gap-1 items-center">
													<p className="text-[10px]">
														{numify(
															item.diamondsRewards
														)}
													</p>

													<DiamondImage classes="drop-shadow-sm w-[20px]" />
												</div>
											</div>
										</div>
									);
								})}
							</div>
						</ScrollArea>
					</div>
					<DrawerFooter>
						<DrawerClose asChild></DrawerClose>
					</DrawerFooter>
				</div>
			</DrawerContent>
		</Drawer>
	);
};
